import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2e015627"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header pb-2",
  style: {"position":"relative"}
}
const _hoisted_5 = { class: "card-title d-flex align-items-start flex-column" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-label fw-bolder fs-4 mb-1" }, "Informações do agendamento", -1))
const _hoisted_7 = {
  key: 0,
  class: "text-muted mt-1 mb-0 fs-7 fw-light"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "text-muted mt-1 mb-1 fs-7 fw-light"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 2,
  class: "text-muted mt-1 mb-1 fs-7 fw-light"
}
const _hoisted_12 = { class: "modal-body pb-10" }
const _hoisted_13 = {
  key: 0,
  class: "row"
}
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Tipo de tarefa", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Técnico responsável", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_22 = {
  key: 1,
  class: "row"
}
const _hoisted_23 = { class: "col" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, " Horário inicial ", -1))
const _hoisted_25 = { class: "col d-flex flex-column" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, " Horário final ", -1))
const _hoisted_27 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_28 = {
  key: 2,
  class: "modal-footer d-flex justify-content-between pb-0 px-0"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M12,22 C7.02943725,22 3,17.9705627 3,13 C3,8.02943725 7.02943725,4 12,4 C16.9705627,4 21,8.02943725 21,13 C21,17.9705627 16.9705627,22 12,22 Z",
        fill: "#000000",
        opacity: "0.3"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M11.9630156,7.5 L12.0475062,7.5 C12.3043819,7.5 12.5194647,7.69464724 12.5450248,7.95024814 L13,12.5 L16.2480695,14.3560397 C16.403857,14.4450611 16.5,14.6107328 16.5,14.7901613 L16.5,15 C16.5,15.2109164 16.3290185,15.3818979 16.1181021,15.3818979 C16.0841582,15.3818979 16.0503659,15.3773725 16.0176181,15.3684413 L11.3986612,14.1087258 C11.1672824,14.0456225 11.0132986,13.8271186 11.0316926,13.5879956 L11.4644883,7.96165175 C11.4845267,7.70115317 11.7017474,7.5 11.9630156,7.5 Z",
        fill: "#000000"
      })
    ])
  ])
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M12,22 C7.02943725,22 3,17.9705627 3,13 C3,8.02943725 7.02943725,4 12,4 C16.9705627,4 21,8.02943725 21,13 C21,17.9705627 16.9705627,22 12,22 Z",
        fill: "#000000",
        opacity: "0.3"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M11.9630156,7.5 L12.0475062,7.5 C12.3043819,7.5 12.5194647,7.69464724 12.5450248,7.95024814 L13,12.5 L16.2480695,14.3560397 C16.403857,14.4450611 16.5,14.6107328 16.5,14.7901613 L16.5,15 C16.5,15.2109164 16.3290185,15.3818979 16.1181021,15.3818979 C16.0841582,15.3818979 16.0503659,15.3773725 16.0176181,15.3684413 L11.3986612,14.1087258 C11.1672824,14.0456225 11.0132986,13.8271186 11.0316926,13.5879956 L11.4644883,7.96165175 C11.4845267,7.70115317 11.7017474,7.5 11.9630156,7.5 Z",
        fill: "#000000"
      })
    ])
  ])
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M12,22 C7.02943725,22 3,17.9705627 3,13 C3,8.02943725 7.02943725,4 12,4 C16.9705627,4 21,8.02943725 21,13 C21,17.9705627 16.9705627,22 12,22 Z",
        fill: "#000000",
        opacity: "0.3"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M11.9630156,7.5 L12.0475062,7.5 C12.3043819,7.5 12.5194647,7.69464724 12.5450248,7.95024814 L13,12.5 L16.2480695,14.3560397 C16.403857,14.4450611 16.5,14.6107328 16.5,14.7901613 L16.5,15 C16.5,15.2109164 16.3290185,15.3818979 16.1181021,15.3818979 C16.0841582,15.3818979 16.0503659,15.3773725 16.0176181,15.3684413 L11.3986612,14.1087258 C11.1672824,14.0456225 11.0132986,13.8271186 11.0316926,13.5879956 L11.4644883,7.96165175 C11.4845267,7.70115317 11.7017474,7.5 11.9630156,7.5 Z",
        fill: "#000000"
      })
    ])
  ])
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M12,22 C7.02943725,22 3,17.9705627 3,13 C3,8.02943725 7.02943725,4 12,4 C16.9705627,4 21,8.02943725 21,13 C21,17.9705627 16.9705627,22 12,22 Z",
        fill: "#000000",
        opacity: "0.3"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M11.9630156,7.5 L12.0475062,7.5 C12.3043819,7.5 12.5194647,7.69464724 12.5450248,7.95024814 L13,12.5 L16.2480695,14.3560397 C16.403857,14.4450611 16.5,14.6107328 16.5,14.7901613 L16.5,15 C16.5,15.2109164 16.3290185,15.3818979 16.1181021,15.3818979 C16.0841582,15.3818979 16.0503659,15.3773725 16.0176181,15.3684413 L11.3986612,14.1087258 C11.1672824,14.0456225 11.0132986,13.8271186 11.0316926,13.5879956 L11.4644883,7.96165175 C11.4845267,7.70115317 11.7017474,7.5 11.9630156,7.5 Z",
        fill: "#000000"
      })
    ])
  ])
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M6,8 L18,8 L17.106535,19.6150447 C17.04642,20.3965405 16.3947578,21 15.6109533,21 L8.38904671,21 C7.60524225,21 6.95358004,20.3965405 6.89346498,19.6150447 L6,8 Z M8,10 L8.45438229,14.0894406 L15.5517885,14.0339036 L16,10 L8,10 Z",
        fill: "#000000",
        "fill-rule": "nonzero"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M14,4.5 L14,3.5 C14,3.22385763 13.7761424,3 13.5,3 L10.5,3 C10.2238576,3 10,3.22385763 10,3.5 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z",
        fill: "#000000",
        opacity: "0.3"
      })
    ])
  ])
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-check" })
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-times" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade show",
    id: `kt_modal_event_info_${_ctx.id}`,
    "aria-modal": "true",
    role: "dialog",
    ref: "newTargetModalRef"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          class: "form fv-plugins-bootstrap5 fv-plugins-framework",
          id: "kt_modal_add_event_form",
          onSubmit: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.targetData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, [
                _hoisted_6,
                (_ctx.targetData.codTipoServico < 9)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                      _createTextVNode(_toDisplayString(_ctx.targetData.cliente) + " - " + _toDisplayString(_ctx.targetData.placa ? _ctx.targetData.placa : _ctx.targetData.chassi), 1),
                      (_ctx.targetData.modelo)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, " - " + _toDisplayString(_ctx.targetData.modelo), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.targetData.codTipoServico != 10 && _ctx.targetData.codTipoServico != 11)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                      _createTextVNode(_toDisplayString(_ctx.targetData.taskDateTratada), 1),
                      (_ctx.targetData.codTipoServico < 9 && _ctx.targetData.taskHourRecepcao != '00:00')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" - Recepção: " + _toDisplayString(_ctx.targetData.taskHourRecepcao), 1),
                            (_ctx.targetData.taskHourEntrega != '00:00')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "- Entrega: " + _toDisplayString(_ctx.targetData.taskHourEntrega), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.targetData.codTipoServico < 9 && _ctx.targetData.consultorAgendado)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Consultor: " + _toDisplayString(_ctx.targetData.consultorAgendadoTratado), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                style: {"position":"absolute","right":"25px","top":"25px"},
                type: "button",
                class: "btn-close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal())),
                "aria-label": "Close"
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.targetData.codTipoServico < 9 && _ctx.targetData.detalhes)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("p", null, "Observações: " + _toDisplayString(_ctx.targetData.detalhes), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_el_form_item, { prop: "taskType" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.targetData.taskType,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.targetData.taskType) = $event)),
                        type: "text",
                        readonly: true,
                        name: "eventName"
                      }, null, 8, ["modelValue"]),
                      _hoisted_18
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_el_form_item, { prop: "taskType" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.targetData.tecnico,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetData.tecnico) = $event)),
                        type: "text",
                        readonly: true,
                        name: "eventName"
                      }, null, 8, ["modelValue"]),
                      _hoisted_21
                    ]),
                    _: 1
                  })
                ])
              ]),
              (_ctx.targetData.codTipoServico != 10 && _ctx.targetData.codTipoServico != 11)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.targetData.taskStartHour,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.targetData.taskStartHour) = $event)),
                        readonly: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createVNode(_component_el_input, {
                        readonly: true,
                        modelValue: _ctx.targetData.taskEndHour,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.targetData.taskEndHour) = $event))
                      }, null, 8, ["modelValue"]),
                      (_ctx.targetData.tempoAdicional)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("span", null, " Horario final sem tempo adicional: " + _toDisplayString(_ctx.targetData.endWithout), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showStatusControl || _ctx.editable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    (_ctx.showStatusControl && (_ctx.targetData.status == 1 || _ctx.targetData.status == 5) && _ctx.targetData.codTipoServico < 9 && !(_ctx.hidenButtonDms.includes(_ctx.dms) && _ctx.aberturaOS == 1) && !_ctx.configSchedule?.name)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: _normalizeClass(["btn btn-sm background_btn_1_opct text-white btn-flex ms-4", {'disabled': _ctx.loadingBtn}]),
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.iniciarServico()))
                        }, [
                          _hoisted_29,
                          _createTextVNode(" Iniciar serviço ")
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.showStatusControl && _ctx.targetData.status == 2 && _ctx.targetData.codTipoServico < 9 && !(_ctx.hidenButtonDms.includes(_ctx.dms) && _ctx.aberturaOS == 1) && !_ctx.configSchedule?.name )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: _normalizeClass(["btn btn-sm background_btn_1_opct btn-flex btn-outline border_btn_1 cor_btn_1", {'disabled': _ctx.loadingBtn}]),
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cancelarServico()))
                        }, [
                          _hoisted_30,
                          _createTextVNode(" Voltar para planejamento ")
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.showStatusControl && _ctx.targetData.codTipoServico < 9 && _ctx.modeloAgendaName == 'CampV1' && _ctx.targetData.status == 2)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: _normalizeClass(["btn btn-sm background_btn_1_opct text-white btn-flex ms-4", {'disabled': _ctx.loadingBtn}]),
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.paralisarServico())),
                          type: "button"
                        }, [
                          _hoisted_31,
                          _createTextVNode(" Paralisar serviço ")
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.showStatusControl && _ctx.targetData.status == 2 && _ctx.targetData.codTipoServico < 9 && !(_ctx.hidenButtonDms.includes(_ctx.dms) && _ctx.aberturaOS == 1) && !_ctx.configSchedule?.name)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          class: _normalizeClass(["btn btn-sm background_btn_1_opct text-white btn-flex ms-4", {'disabled': _ctx.loadingBtn}]),
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.finalizarServico()))
                        }, [
                          _hoisted_32,
                          _createTextVNode(" Encerrar serviço ")
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.editable)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 4,
                          class: _normalizeClass(["btn btn-sm background_btn_1_opct text-white btn-flex", {'disabled': _ctx.loadingBtn}]),
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deletarEvento()))
                        }, [
                          _hoisted_33,
                          _createTextVNode(" Excluir ")
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.editable && _ctx.showEntregaControl && _ctx.targetData.status == 3)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 5,
                          class: _normalizeClass(["btn btn-sm background_btn_1_opct text-white btn-flex", {'disabled': _ctx.loadingBtn}]),
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.entregaAoClienteRealizada()))
                        }, [
                          _hoisted_34,
                          _createTextVNode(" Entregue ao cliente ")
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.editable && _ctx.showEntregaControl && _ctx.targetData.status == 4)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 6,
                          class: _normalizeClass(["btn btn-sm background_btn_1_opct text-white btn-flex", {'disabled': _ctx.loadingBtn}]),
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.cancelarEntregaAoClienteRealizada()))
                        }, [
                          _hoisted_35,
                          _createTextVNode(" Cancelar entrega ao cliente ")
                        ], 2))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 8, _hoisted_1))
}